module.exports = __webpack_public_path__ + "static/media/purple-light.2bfabd9d.svg";